import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { FilterList, Sync } from '@mui/icons-material';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { filterRangeValues } from '../../constants';
import { Card, Autocomplete, Slider, IconButton } from '@totalsoft/rocket-ui';
import { FilterSliderWrapper } from 'features/simulator/SimulatorStyles';
import { RangeSlider } from 'components/common';
import { onSliderChange } from 'utils/propertyChangeAdapters';

const SimulatorFilters = ({ t, filterValues, handleFiltersChange, assetTypes, onLoadSimulatorAssets, assetsLoading }) => {
  return (
    <Card icon={FilterList} title={assetsLoading ? t('Simulator.Status.Loading') : t('Simulator.Status.Init')}>
      <Grid container spacing={3} alignItems='center'>
        <Grid item flexGrow={1}>
          <Grid container spacing={3} justifyContent='space-evenly'>
            <Grid item xs={12} lg={3} mt={1}>
              <Autocomplete
                label={t('Simulator.Filters.AssetType')}
                fullWidth
                required
                error={false}
                isSearchable={false}
                isClearable={false}
                valueKey='assetTypeId'
                simpleValue={true}
                value={filterValues.assetTypeId || ''}
                onChange={handleFiltersChange('assetTypeId')}
                options={assetTypes}
                disabled={true}
              />
            </Grid>
            <FilterSliderWrapper item xs={12} lg={3}>
              <RangeSlider
                label={t('Simulator.Filters.MonthlyRate')}
                value={filterValues.monthlyRate}
                min={filterRangeValues.monthlyRate.minValue}
                max={filterRangeValues.monthlyRate.maxValue}
                step={filterRangeValues.monthlyRate.step}
                decimalScale={0}
                disabled={assetsLoading}
                fullWidth={true}
                required={true}
                showSliderLimits={true}
                onChange={onSliderChange(handleFiltersChange('monthlyRate'))}
              />
            </FilterSliderWrapper>
            <FilterSliderWrapper item xs={12} lg={3}>
              <Slider
                label={t('Simulator.Filters.FinancingPeriod')}
                value={filterValues.financingPeriod}
                min={filterRangeValues.financingPeriod.minValue}
                max={filterRangeValues.financingPeriod.maxValue}
                step={filterRangeValues.financingPeriod.step}
                decimalScale={0}
                disabled={assetsLoading}
                fullWidth
                required={true}
                showSliderLimits={true}
                onChange={handleFiltersChange('financingPeriod')}
              />
            </FilterSliderWrapper>
            <FilterSliderWrapper item xs={12} lg={3}>
              <Slider
                label={t('Simulator.Filters.Advance')}
                value={filterValues.advance}
                min={filterRangeValues.advance.minValue}
                max={filterRangeValues.advance.maxValue}
                step={filterRangeValues.advance.step}
                decimalScale={0}
                disabled={assetsLoading}
                fullWidth
                required={true}
                showSliderLimits={true}
                onChange={handleFiltersChange('advance')}
              />
            </FilterSliderWrapper>
          </Grid>
        </Grid>
        <Grid item>
          <IconButton
            color='primary'
            variant='text'
            tooltip={t('Search')}
            onClick={onLoadSimulatorAssets}
            disabled={assetsLoading || !assetTypes.isLoaded}
          >
            <Sync />
          </IconButton>
        </Grid>
      </Grid>
    </Card>
  );
};

SimulatorFilters.propTypes = {
  t: PropTypes.func.isRequired,
  filterValues: PropTypes.object.isRequired,
  handleFiltersChange: PropTypes.func.isRequired,
  assetTypes: PropTypes.array.isRequired,
  onLoadSimulatorAssets: PropTypes.func.isRequired,
  assetsLoading: PropTypes.bool.isRequired
};

export default compose(withTranslation())(SimulatorFilters);
